export const currencyFormat = (money: number, cents: boolean, currency = "USD") => {
  return Intl.NumberFormat("en", {
    style: "currency",
    currency: currency,
    maximumSignificantDigits: !cents ? money.toString().length : undefined,
  }).format(money);
};
